import React from "react";
import './SurveyBuilderQuestionCarryForward.scss';
import i18next from "i18next";
import cloneDeep from "lodash/cloneDeep";
import LabeledSwitch from "../../../../Custom UI/LabeledInputs/LabeledSwitch/LabeledSwitch";

export default class SurveyBuilderQuestionCarryForward extends React.Component{
  
  // Instance Variables
  
  
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
    
    };
  }
  
  // Methods
  
  
  
  // Render
  
  render(){
    const {disabled, question, updateQuestion} = this.props;
    
    return(
      <div className="survey-builder-question-carry-forward">
        <LabeledSwitch className="survey-builder-question-carry-forward-switch"
                       label={i18next.t('CARRY_FORWARD')}
                       checked={question && Boolean(question.carry_forward)}
                       disabled={disabled}
                       onChange={(isChecked) => {
                         let updatedQuestion = cloneDeep(question);
          
                         if(isChecked){
                           if(!updatedQuestion.carry_forward){
                             updatedQuestion.carry_forward = true;
                           }
                         }
                         else{
                           delete updatedQuestion['carry_forward'];
                         }
                         updateQuestion(updatedQuestion);
                       }}
                       infoBlurb={i18next.t('CARRY_FORWARD_EXPLANATION')}
                       popoverPlacement={'left'}
        />
      </div>
    )
  }
}
